import { Typography } from "@mui/material";
import momentZone from "moment-timezone";

import { DemoUser } from "../../../Type";

export default function LastConnection({ lastConnection }: DemoUser) {
	const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
	const dateInUtc = momentZone(lastConnection).utc(true).tz(timeZone);
	return <Typography variant='subtitle2'>{dateInUtc.format("lll")}</Typography>;
}
